import { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as Icon } from 'assets/icons/thank-you-check.svg';
import ExtraHeader from 'components/ExtraHeader';
import styles from './QuestionnaireThankYouPage.module.scss';

const QuestionnaireThankYouPage = (): ReactElement => {
  const message = localStorage.getItem('thankYouMessage') || 'screening.thankYou.default';

  return (
    <>
      <ExtraHeader title="screening.header.title" />
      <div className="container">
        <div className={styles.messageContainer}>
          <Icon />
          <FormattedMessage id={message} />
        </div>
      </div>
    </>
  );
};

export default QuestionnaireThankYouPage;
